import React from 'react';

import GanttDates from './GanttDates';

const GanttHeader = ({
  dateMode,
  dateAlignMode,
  colSize = 28,
  colCount,
  colOffset,
}) => {
  return (
    <React.Fragment>
      <GanttDates 
        colSize={colSize}
        colCount={colCount}
        colOffset={colOffset}
        dateMode={dateMode}
        dateAlignMode={dateAlignMode}
      />
    </React.Fragment>
  );
};

export default GanttHeader;
